/* A Set is one Reader plus one Printed Lab Manual, not a separate stock item. */
if (!customElements.get('mos-set-form')) {
  customElements.define(
    'mos-set-form',
    class MosSetForm extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;

        this.form = this.querySelector('form');
        this.button = this.querySelector('button[type="submit"]');
        this.buttonLabel = this.button.querySelector('span');
        this.errorWrapper = this.querySelector('[role="alert"]');
        this.errorText = this.errorWrapper.querySelector('.product-form__error-message');

        const idsAreValid = /^\d+$/.test(this.dataset.readerVariantId || '') &&
          /^\d+$/.test(this.dataset.manualVariantId || '');
        if (idsAreValid && this.dataset.componentsAvailable === 'true') {
          this.button.disabled = false;
        }

        this.form.addEventListener('submit', (event) => this.addSet(event));
      }

      async addSet(event) {
        event.preventDefault();
        if (this.button.disabled || this.isAdding) return;

        const quantity = Number(new FormData(this.form).get('quantity') || 1);
        if (!Number.isSafeInteger(quantity) || quantity < 1) {
          this.showError('Enter a valid number of sets.');
          return;
        }

        this.isAdding = true;
        this.button.disabled = true;
        this.buttonLabel.textContent = 'Adding both books…';
        this.showError('');

        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const localeRoot = root.endsWith('/') ? root : root + '/';

        try {
          const response = await fetch(localeRoot + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [
                { id: this.dataset.readerVariantId, quantity },
                { id: this.dataset.manualVariantId, quantity },
              ],
            }),
          });
          const result = await response.json();
          if (!response.ok || result.status) {
            throw new Error(result.description || result.message || 'The books could not be added.');
          }

          window.location.assign(window.routes?.cart_url || localeRoot + 'cart');
        } catch (error) {
          this.showError(error.message + ' Please check your cart before trying again.');
          this.button.disabled = false;
          this.buttonLabel.textContent = 'Add both books to cart';
          this.isAdding = false;
        }
      }

      showError(message) {
        this.errorWrapper.hidden = !message;
        this.errorText.textContent = message;
      }
    }
  );
}